import React,{useState, useEffect} from "react";

// import { Divider, Drawer, Space, Button } from "antd";
import { Link,useNavigate } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import {getAllOrdersAction} from "../../store/order/actions"
import {getOrders, reset} from "../../store/order/orderSlice"

import { useSelector,useDispatch } from "react-redux";
import OrdersSkeleton from "./OrdersSkeleton";

const Orders = () => {
    const navigate = useNavigate();

    const { user } = useSelector((state: any) => state.auth);

    const {orders, isLoading, isError, message} = useSelector(
        (state:any) => state.order)
    const dispatch = useDispatch<any>();

    useEffect(() => {
        if(isError) {
          console.log(message)
        }
        if(!user) {
          navigate('/login')
        }
        // if(isSuccess && user){
        dispatch(getOrders(`?orderedBy=${user?.user?._id}`))
        // }
        return () => {
          dispatch(reset())
        }
        console.log("orders-----",orders);

      },[user,isError,message,navigate,dispatch])

    // useEffect(() => {
    //     user && getAllOrdersAction(`?orderedBy=${user?.user?._id}`)(dispatch);
    // }, [user, dispatch]);
  return (
    <Layout>
     <div className="cart-table-area section-padding-100">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-lg-12">
                        <div className="cart-title mt-50">
                            <h2>My Orders</h2>
                        </div>

                        <div className="cart-table clearfix">
                            <table className="table table-responsive">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Name</th>
                                        <th>Price</th>
                                        <th>Quantity</th>
                                        <th>Status</th>

                                    </tr>
                                </thead>
                                <tbody>
                             
                                {orders?.map((el: any, index: any) => (
                                    <tr key={index}>
                                        <td className="cart_product_img">
                                            <a href="#"><img src={el?.product?.images[0]} alt="Product"/></a>
                                        </td>
                                        <td className="cart_product_desc">
                                            <h5>{el?.product?.product}</h5>
                                            <p>{el?.orderID}</p>
                                        </td>
                                        <td className="price">
                                            <span>{`RWF ${el?.totalPrice}`}</span>
                                        </td>
                                        <td className="qty">
                                             <span>{el?.quantity}</span>
                                            
                                        </td>
                                        <td className="qty">
                                             <span>{el?.status}</span>
                                            
                                        </td>
                                       
                                    </tr>
                                    ))}
                                
                                {isLoading && <OrdersSkeleton cards={3} />}
                                   
                                </tbody>
                            </table>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
      
    </Layout>
  );
};

export default Orders;
